<template>
  <footer>
    <div class="footer container-fluid">
      <div class="row mt-2 m-0 align-items-center">
        <div class="col-md-4 d-sm-none d-md-block"></div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <ul class="footer-ul">
            <h5 class="d-inline-block">QUICK LINKS</h5>

            <li class="mt-2">
              <router-link
                to="/contact"
                class="nav-link"
                active-class="active"
                @click.native="scrollToTop()"
                exact
              >
                <span>Contact Us</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'policy', params: { name: 'termsandcondition' } }"
                class="nav-link"
                active-class="active"
                @click.native="scrollToTop()"
                exact
              >
                <span>Terms and Conditions</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'policy', params: { name: 'privacypolicy' } }"
                class="nav-link"
                active-class="active"
                @click.native="scrollToTop()"
                exact
              >
                <span>Privacy Policy</span>
              </router-link>
            </li>
            <li>
              <router-link
                :to="{ name: 'policy', params: { name: 'returnpolicy' } }"
                class="nav-link"
                active-class="active"
                @click.native="scrollToTop()"
                exact
              >
                <span>Return and Refund Policy</span>
              </router-link>
            </li>
            <li>
              <router-link
                to="/faq"
                class="nav-link"
                active-class="active"
                @click.native="scrollToTop()"
                exact
              >
                <span>FAQ's</span>
              </router-link>
            </li>
            <li class="mb-2">
              <router-link
                to="/contributors"
                class="nav-link"
                active-class="active"
                @click.native="scrollToTop()"
                exact
              >
                <span>Contributors</span>
              </router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-4 col-sm-6 col-xs-12">
          <a class="icon" href="/">
            <img
              src="../assets/img/logo.png"
              class="img-fluid icon align-self-center pr-1"
              alt="logo"
            />
            <span class="f-theme-color-inverse fa">Fasdo</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style scoped>
.footer {
  background: #4b4658;
  text-align: center;
  padding: 5px 0;
  background-position: bottom;
}
.footer-ul {
  padding: 0;
  margin: 0;
}
.footer-ul {
  display: block;
}
.footer-ul li {
  list-style-type: none;
}
.footer-ul h5 {
  color: rgb(252, 246, 246);
  padding-bottom: 0.5em;
  border-bottom: 5px solid #ee5214;
}

.footer-ul li a {
  color: rgb(252, 246, 246);
  font-weight: 300;
  text-decoration-line: none;
}
.footer-ul li a:hover {
  text-decoration-line: none;
}
footer .icon {
  text-align: center;
}
footer .icon img {
  width: 3em;
}
footer .icon .fa {
  font-weight: 700;
  text-transform: uppercase;
  color: #fff;
}
@media (max-width: 768px) {
  .col-sm-6,
  footer .icon {
    padding-top: 20px;
  }
}
@media (max-width: 575px) {
  .footer-ul {
    padding-top: 10px;
    letter-spacing: 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue